<template>
<div v-if="activate()">
    <button
        :class="types[type] + ' ' + colors[color] + ' ' + pointer + ' ' + css"
        :title="title"
        @click="click($event)">
        <i :class="icons[icon]"></i>
        {{ label }}
    </button>
</div>
</template>
<script>

import { AppService } from "../../services"

export default {
    name: "Button",
    props: {
        label: {
            type: String,
            default: ""
        },
        title: {
            type: String,
            default: ""
        },
        type: {
            type: String,
            default: "default"
        },
        color: {
            type: String,
            default: "default"
        },
        icon: {
            type: String,
            default: "default"
        },
        activationCode: {
            type: String,
            default: null
        },
        activation: {
            type: Boolean,
            default: null
        },
        noPointer: {
            type: Boolean,
            default: false
        },
        css: {
            type: String,
            default: ""
        }
    },
    data() {
        return {
            types: {
                default: "nj-button",
                icon: "nj-button icon",
            },
            colors: {
                default: "c-gray",
                dark_blue: "c-dark-blue",
                blue: "c-blue",
                green: "c-green",
                red: "c-red",
            },
            icons: {
                add: "mdi-file-plus",
                attachment: "mdi-attachment",
                calendar: "mdi-calendar",
                cancel: "mdi-close",
                cart: "mdi mdi-cart",
                check: "mdi-check",
                copy: "mdi-content-copy",
                default: "mdi-arrow-right-bold",
                delete: "mdi-delete",
                doc: "mdi-file-document-box",
                doubleCheck: "mdi-check-all",
                download: "mdi-cloud-download",
                edit: "mdi-pencil",
                email: "mdi-email",
                excel: "mdi-file-excel-box",
                info: "mdi-information",
                leftArrow: "mdi-arrow-left-bold",
                money: "mdi-cash-multiple",
                pdf: "mdi-file-pdf-box",
                redo: "mdi-redo-variant",
                review: "mdi-check-all",
                save: "mdi-content-save",
                search: "mdi-file-find",
                transfer: "mdi mdi-transfer",
                complete: "mdi-checkbox-multiple-marked",
            }
        }
    },
    computed: {
        pointer() {
            return this.noPointer
                ? "noPointer"
                : ""
        }
    },
    methods: {
        click(event) {
            this.$emit("click", event)
        },
        setType() {
            return this.icon ? "nj-button icon" : "nj-button"
        },
        activate() {
            let firstCondition = this.activationCode != null ? AppService.activarOpcion(this.activationCode) : true
            let secondCondition = this.activation != null ? this.activation : true
            return firstCondition && secondCondition
        },
    },
    mounted() {

    }
}
</script>

<style scoped>
.noPointer {
    cursor: default !important;
}

.noPointer * {
    cursor: default !important;
}
</style>